import { CalendarRange, ShieldCheck, Gauge } from "lucide-react";

const benefits = [
  {
    id: "benefit-card-roadmap",
    tag: "01. Predictive Visibility",
    title: "30-Day Payment Roadmap",
    description:
      "Never get ambushed by a forgotten annual charge or staggered credit cycles. A clear day-by-day cash trajectory that updates as bills shift.",
    badge: "No surprises",
    Icon: CalendarRange,
  },
  {
    id: "benefit-card-buffer",
    tag: "02. Liquidity Shield",
    title: "3-Day Safety Buffer",
    description:
      "Bank transfers take 48–72 hours to settle. Payment Pulse automatically quarantines cash 3 full days ahead of every due date to eliminate overdraft fees forever.",
    badge: "Zero overdrafts",
    Icon: ShieldCheck,
  },
  {
    id: "benefit-card-safe-number",
    tag: "03. Daily Clarity",
    title: "The Safe-to-Spend Number",
    description:
      "One single honest number. Deduct upcoming rent, minimum balances, and buffer before showing what you can actually swipe today without regret.",
    badge: "Guilt-free decisions",
    Icon: Gauge,
  },
];

export const BenefitsBento = () => (
  <section
    id="benefits"
    data-testid="benefits-section"
    className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8"
  >
    <p className="font-mono-num text-xs font-semibold uppercase tracking-[0.2em] text-sky-400">
      Engineered for financial peace
    </p>
    <h2 className="mt-3 max-w-2xl text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
      Three layers of defense against cashflow chaos
    </h2>
    <p className="mt-4 max-w-2xl text-base text-slate-400">
      Whether juggling irregular freelance gigs, bi-weekly salaries, or five
      credit card cycles, Payment Pulse calculates truth in real time.
    </p>
    <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
      {benefits.map(({ id, tag, title, description, badge, Icon }) => (
        <article
          key={id}
          data-testid={id}
          className="group flex flex-col gap-5 rounded-2xl border border-white/10 bg-[#0D1527]/90 p-8 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-sky-400/30"
        >
          <div className="flex items-center justify-between">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-sky-400/10 border border-sky-400/25">
              <Icon className="h-5 w-5 text-sky-400" />
            </span>
            <span className="rounded-full border border-emerald-400/25 bg-emerald-400/10 px-3 py-1 text-[11px] font-medium text-emerald-300">
              {badge}
            </span>
          </div>
          <div>
            <p className="font-mono-num text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">
              {tag}
            </p>
            <h3 className="mt-2 text-xl font-semibold tracking-tight text-white sm:text-2xl">
              {title}
            </h3>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">{description}</p>
        </article>
      ))}
    </div>
  </section>
);
